import { Component, Input, OnInit } from '@angular/core';
import { TranslateHelper } from '@app/_helpers'
import { VariantProductComponent } from '../variant-product/variant-product.component';
import { NgIf, NgFor, KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-variant-product-items',
    templateUrl: './variant-product-items.component.html',
    styleUrls: ['./variant-product-items.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, NgFor, VariantProductComponent, KeyValuePipe]
})
export class VariantProductItemsComponent implements OnInit {
    @Input() currentProductId;
    @Input() productVariants;

    constructor(
        public translateHelper: TranslateHelper
    ) { }

    ngOnInit(): void {
        // console.log(this.productVariants);
    }
}
